import { toStatisticNumber } from 'utils/statisticNumber';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import routerActions from 'app/routerActions';
import { api, apiUtils } from 'app/services';
import * as actions from 'app/actions';
import {
KBLoadingContainer,
KBAvatar,
KBRangeDate,
KBPopover,
KBTipsy } from
'components';
import * as selectors from 'app/selectors';
import { KBDropSelect } from 'components/plugins';
import dayjs from 'utils/dayjs';
import { STATISTIC_CYCLE } from 'app/constants';
import { KBSelect } from 'components/views';
import { InitialHighCharts } from 'components/mixins';
import { percent, getYMD } from 'utils/kbUtil';
import {
extendDefaultHighchartsConfig,
getStatisticInitialDate,
getInitialDate } from
'utils/kbData';

var StatisticMeetingReserveCountTrend = class extends React.Component {constructor(props) {super(props);this.state = this.getInitialState();this.parseLoadFromTo = this.parseLoadFromTo.bind(this);this._loadData = this._loadData.bind(this);this.parseJSON = this.parseJSON.bind(this);this.compare = this.compare.bind(this);this.fillChart = this.fillChart.bind(this);this._setFilters = this._setFilters.bind(this);this.changeDate = this.changeDate.bind(this);this.cycleChange = this.cycleChange.bind(this);this.selectCallBack = this.selectCallBack.bind(this);this.setMonthFilters = this.setMonthFilters.bind(this);}getInitialState()

  {
    const { from, to } = getStatisticInitialDate(new Date(), 'daily');
    return {
      filters: {
        from,
        to,
        cycle: 'daily' },

      data: [],
      month: '' };

  }componentDidMount()

  {
    const { filters, data } = this.state;
    let Highcharts = this.getHighcharts();
    let filtersMonths = dayjs(filters.to).diff(dayjs(filters.from), 'months');

    this.mounted = true;
    this.setState({
      month: filtersMonths });

    this._loadData(filters);
    this.renderChart(
    'Chart',
    extendDefaultHighchartsConfig({
      chart: {
        type: 'spline' },

      title: {
        text: null },

      xAxis: {
        type: 'datetime',
        dateTimeLabelFormats: {
          // don't display the dummy year
          month: '%e. %b',
          year: '%b' },

        title: {
          text: '时间' },

        labels: {
          format: '{value:%Y-%m-%d}' } },


      yAxis: {
        title: {
          text: '时间数' } },


      tooltip: {
        headerFormat: '<b>{series.name}</b><br>',
        pointFormat: '日期：{point.x:%Y-%m-%d}, 时间数：{point.y}' },

      plotOptions: {
        spline: {
          marker: {
            enabled: true } } },



      series: data }));


  }componentWillUnmount()

  {
    this.mounted = false;
  }parseLoadFromTo(


  params, from, to) {
    delete params.from;
    delete params.to;

    params.start_date = from ? getInitialDate(from).initStartDateString : null;
    params.end_date = to ? getInitialDate(to).initEndDateString : null;

    return params;
  }_loadData(

  filters) {
    const { locations } = this.props;
    const { from, to, location_ids, cycle } = filters;
    var params = { location_ids, cycle };
    if (!location_ids && locations) {
      params.location_ids = locations.map(json => json.id).join(',');
    }

    // 判断日期
    params = this.parseLoadFromTo(params, from, to);

    api.getReserveCountTrendStatistic(params).then(({ json }) => {
      if (!json.length) {
        return;
      }
      this.parseJSON(json);
    });
  }parseJSON(

  json) {
    var contain = {};
    let data = [];

    if (!json || !Object.keys(json).length) {
      if (this.mounted) {
        this.setState({
          data });

      }
    }

    var array = json;
    var dt = { name: '预定数量', data: [] };
    var dr = { name: '预定时间长度', data: [] };
    array.forEach(json => {
      let { year, month, day } = getYMD(json.date);
      dt.data.push([Date.UTC(year, month, day), toStatisticNumber(json.total_count)]);
      dr.data.push([Date.UTC(year, month, day), toStatisticNumber(json.renting_minute)]);
    });

    dt.data.sort(this.compare);
    dr.data.sort(this.compare);

    data.push(dt);
    data.push(dr);
    this.fillChart(data);
  }compare(

  a, b) {
    if (!a || !b || !a[0] || !b[0]) {
      return 0;
    }

    if (a[0] - b[0] > 0) {
      return 1;
    } else if (a[0] - b[0] < 0) {
      return -1;
    }

    return 0;
  }fillChart(

  data) {
    this.setSerierDate(data);
  }_setFilters(

  obj) {
    let newFilters = Object.assign({}, this.state.filters, obj);
    this.setState({
      filters: newFilters });

    this._loadData(newFilters);
  }changeDate(

  range) {
    this._setFilters(range);
    this.setState({
      month: '' });

  }cycleChange(

  data) {
    this._setFilters({
      cycle: data });

  }selectCallBack(

  data) {
    this._setFilters({
      location_ids: data.map(json => json.id).join(',') });

  }setMonthFilters(

  num = 1) {
    var to = dayjs().toDate();
    var from = dayjs().
    subtract(num, 'months').
    toDate();

    this.setState({
      month: num });


    this._setFilters({
      from,
      to });

  }render()

  {
    const { locations } = this.props;
    const { filters, data, month } = this.state;
    const { from, to, cycle } = filters;
    return (
      <article>
        <div className="chart-title m-top-lg">
          <span>总预定数和预订时间长度按周期变化</span>
          <button className="bordered-btn-small" onClick={this.print}>
            <i className="iconfont icon-contract" />
            打印
          </button>
          <button className="bordered-btn-small" onClick={this.exportingExcel}>
            <i className="iconfont icon-EXCEL" />
            导出Excel
          </button>
        </div>
        <div className="m-bottom-sm">
          <KBRangeDate
          format="YYYY/MM/DD"
          from={from || ''}
          to={to || ''}
          callback={this.changeDate}
          leftNone={true} />

          <div className="time-filter">
            <button
            className={month == 1 ? 'active' : ''}
            onClick={this.setMonthFilters.bind(null, 1)}>

              1个月
            </button>
            <button
            className={month == 3 ? 'active' : ''}
            onClick={this.setMonthFilters.bind(null, 3)}>

              3个月
            </button>
            <button
            className={month == 6 ? 'active' : ''}
            onClick={this.setMonthFilters.bind(null, 6)}>

              6个月
            </button>
            <button
            className={month == 12 ? 'active' : ''}
            onClick={this.setMonthFilters.bind(null, 12)}>

              1年
            </button>
          </div>
          <KBDropSelect
          options={{ defaultSelectPrompt: '选择分店' }}
          defaultData={locations}
          multi={true}
          callback={this.selectCallBack}
          style={{ marginLeft: 20 }} />

        </div>
        <div ref={ref => { this.highcharts = ref; }} />
      </article>);

  }};Object.assign(StatisticMeetingReserveCountTrend.prototype, InitialHighCharts);


function mapStateToProps(state, props) {
  // const locations = selectors.getSerializeLocation(state)
  const { group_id } = props;
  const locations = selectors.getSerializeGroupsLocation(state, group_id);
  return {
    locations };

}

function mapDispatchToProps(dispatch) {
  return {};
}

export default connect(
mapStateToProps,
mapDispatchToProps)(
StatisticMeetingReserveCountTrend);
